import React from 'react';
import { FaFileWord } from 'react-icons/fa';
import { useAppStore } from "../../../../../../../GlobalStore/GlobalStore.ts";

interface DocxViewerProps {
    url: string;
    children: React.ReactNode;
}

const DocxViewer: React.FC<DocxViewerProps> = ({ url, children }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleClick = () => {
        setDynamicStateObj({
            visiblePopup: "enlargedContent",
            enlargedContent: {
                type: "document",
                docType: "docx",
                content: url
            }
        });
    };

    return (
        <span
            onClick={handleClick}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/50 dark:bg-neutral-800
                hover:bg-white dark:hover:bg-neutral-700 transition-all duration-200
                text-neutral-600 dark:text-neutral-300 border border-neutral-200 dark:border-neutral-700
                cursor-pointer"
        >
            <FaFileWord className="h-4 w-4" />
            <span className="text-sm">{children}</span>
        </span>
    );
};

export default DocxViewer;